import { useState } from "react";
import useHttp from "../../hooks/useHttp";
import { CommonModal } from "./CommonVessels";
import HNotification from "../../components/custom/notification/HNotification";

const ImportChat = ({
  appProperties,
  setNumbersList = () => {},
  unipilePhoneNumberObj,
  showImportWhatsAppModal,
  setShowImportWhatsAppModal,
  onSkip,
}) => {
  const effectivePhoneNumberObj =
    unipilePhoneNumberObj || appProperties?.savedNumbers?.find((number) => number?.serviceName === "unipile_whatsapp");
  const [okButtonLoading, setOkButtonLoading] = useState(false);
  const { fetchData } = useHttp();

  const handleImportWhatsApp = () => {
    setOkButtonLoading(true);
    if (effectivePhoneNumberObj?.integId) {
      fetchData(`omessage/contacts/import?integId=${effectivePhoneNumberObj?.integId}`, "POST", null, appProperties, null, null, null)
        .then((response) => {
        response = JSON.parse(response);
        if (response?.data?.success) {
          onSkip();
        } else {
          HNotification.notify({ type: "error", message: "Error", description: response?.data?.data || "Failed to import WhatsApp contacts" });
        }
      })
        .catch((error) => {})
        .finally(() => {
          setOkButtonLoading(false);
        });
    } else {
      setOkButtonLoading(false);
    }
  };

  return (
    <CommonModal
      open={showImportWhatsAppModal}
      header={null}
      contentSpaceSize="large"
      modalCloseIcon={true}
      doOnClose={() => setShowImportWhatsAppModal(false)}
      body={
        <div className="d-flex flex-column align-items-center">
          <div className="staticIconsSprite import-icon" />
          <span className="text-center my-3 fw-bold hs-color-BlackRussian hs-fs-16">Import WhatsApp Contacts?</span>
          <span className="text-center hs-color-dark-grey">
            We can help you get started by importing the last 7 days of chats from your connected WhatsApp number. Do you want to continue?
          </span>
        </div>
      }
      okButtonProps={{
        buttonText: "Yes,Import Contacts",
        onClick: handleImportWhatsApp,
        loading: okButtonLoading,
        type: "primary",
        className: "hs-h-44-px",
      }}
      cancelButtonProps={{
        buttonText: "No, Skip for now",
        onClick: onSkip,
        className: "hs-h-44-px",
        danger: false,
      }}
    />
  );
};

export default ImportChat;
